module.exports = __webpack_public_path__ + "img/about_contact.adf254ba.png";